{
    "yes": "Ja",
    "no": "NEIN",
    "confirm": "Bestätigen",
    "apply": "Anwenden",
    "cancel": "Stornieren",
    "show": "Zeigen",
    "hide": "Verstecken",
    "send": "Schicken",
    "close": "Schließen",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "loading": "Laden",
    "expand": "Expandieren",
    "collapse": "Zusammenbruch",
    "fullscreenEnter": "Geben Sie den Vollbildmodus ein",
    "fullscreenExit": "Beenden Sie den Vollbildmodus",
    "center": "Center",
    "bottom": "Unten",
    "hidden": "Versteckt",
    "all": "Alle",
    "today": "Heute",
    "yesterday": "Gestern",
    "last_7_days": "Letzte 7 Tage",
    "last_30_days": "Letzte 30 Tage",
    "missingData": "Fehlende Informationen",
    "date": "Geburtsdatum",
    "day": "Tag",
    "copied": "Kopiert!",
    "placeholder": "Stellen Sie eine Frage",
    "month": "Monat",
    "year": "Jahr",
    "createdAt": "Erstellungsdatum",
    "selected": "Ausgewählt",
    "page": "Seite",
    "actions": "Aktionen",
    "next": "Nächste",
    "previous": "Vorherige",
    "copy": "Kopie",
    "copyRawCode": "Rohcode kopieren",
    "copyToClipboard": "In die Zwischenablage kopieren",
    "showOriginalText": "Original anzeigen",
    "showTranslatedText": "Übersetzung anzeigen",
    "exactPosition": "Genaue Position",
    "uncertain": "Unsicher",
    "question": "Frage",
    "nothingFound": "Nichts gefunden",
    "venue": "Veranstaltungsort",
    "searchVenue": "Veranstaltungsort suchen...",
    "privacyPolicy": "Datenschutzbestimmungen",
    "popularLanguages": "Beliebt",
    "allLanguages": "Alle Sprachen",
    "memoriBlockedTitle": "Blockiert",
    "memoriBlockedUntil": "Agent blockiert bis {{date}}",
    "memoriBlockedAnon": "Momentan \"{{name}}„Kann nicht antworten, komm hierher zurück {{date}}",
    "memoriBlockedReasonExceedChats": "weil der monatliche Schwellenwert für erlaubte Chats überschritten wurde.",
    "memoriBlockedGiverHelper": "Sie können es weiterhin als Administrator verwalten, andere Benutzer können jedoch nicht damit interagieren.",
    "generatedByAI": "Von KI generierte Antworten können gelegentlich falsche Informationen generieren",
    "reasoning": "Überlegung...",
    "whyThisAnswer": "Warum diese Antwort?",
    "whyThisAnswerHelper": "Diese Antwort wurde automatisch von einer künstlichen Intelligenz auf Basis dieser verifizierten Inhalte generiert.",
    "receiverLabel": "Zugewiesen an",
    "completionsEnabled": "Fortschrittliche KI kann mit automatisch generierten Antworten reagieren, die manchmal falsche Informationen enthalten können",
    "completionProviderDown": "Dieser Zwilling ist mit einer generativen KI von integriert {{provider}}, aber es ist derzeit nicht verfügbar. ",
    "completionProviderMajorOutage": "Dieser Zwilling ist mit einer generativen KI von integriert {{provider}}, aber es ist derzeit nicht verfügbar. Diese Funktion wird nicht verfügbar sein, bis der Service wiederhergestellt ist.",
    "completionProviderPartialOutage": "Dieser Zwilling ist mit einer generativen KI von integriert {{provider}}, aber es ist derzeit nicht verfügbar. Diese Funktion wird nicht verfügbar sein, bis der Service wiederhergestellt ist.",
    "completionProviderDegraded": "Dieser Zwilling ist mit einer generativen KI von integriert {{provider}}, aber es ist derzeit nicht verfügbar. Diese Funktion wird nicht verfügbar sein, bis der Service wiederhergestellt ist.",
    "completionProviderFallbackName": "ein externer Anbieter",
    "completionProviderCheckStatusPage": "Überprüfen Sie die Statusseite",
    "boardOfExperts": "Expertengremium",
    "birthDate": "Geburtsdatum",
    "birthDateHelper": "Wir fragen nur nach Ihrem Geburtsdatum, um Funktionen zu aktivieren oder zu deaktivieren, für die Altersbeschränkungen gelten",
    "underage": "Das müssen Sie mindestens sein {{age}} Jahre alt, um sich anzumelden.",
    "underageTwinSession": "Das müssen Sie mindestens sein {{age}} Jahre alt, um mit diesem Zwilling zu interagieren.",
    "errorFetchingSession": "Fehler beim Laden der Sitzung",
    "errorGettingReferralURL": "Fehler beim Laden des Referrals",
    "errorReopeningSession": "Fehler beim erneuten Öffnen der Sitzung",
    "ageVerification": "Altersüberprüfung",
    "ageVerificationText": "Um mit diesem Zwilling interagieren zu können, müssen Sie mindestens sein {{minAge}} Jahre alt.",
    "nsfw": "NSFW: Dieser Agent enthält Inhalte für Erwachsene",
    "deepThought": "Tiefer Gedanke",
    "deepThoughtHelper": "Deep Thought ist eine erweiterte Funktion der KI, die es Ihnen ermöglicht, Ihre Gespräche voll auszuschöpfen, indem Sie sie verfolgen. ",
    "deepThoughtDisclaimerTitle": "Deep Thought aktiviert",
    "deepThoughtDisclaimer": "Deep Thought ist eine erweiterte Funktion der KI, die es Ihnen ermöglicht, Ihre Gespräche voll auszuschöpfen, indem Sie sie verfolgen. ",
    "deepThoughtPreDisclaimerUnlogged": "Melden Sie sich an, um Deep Thought zu aktivieren.",
    "deepThoughtPreDisclaimerNotAllowed": "Deep Thought ist deaktiviert, da Sie der Nutzung nicht zugestimmt haben. Sie können dies jederzeit in Ihren Kontoeinstellungen ändern.",
    "notEnoughCredits": "Der Autor dieses Zwillings verfügt nicht über genügend Credits, um Ihre Frage zu beantworten.",
    "confirmDialog": {
        "title": "Möchten Sie diese Seite verlassen?",
        "message": "Die Änderungen, die Sie vorgenommen haben, werden verloren."
    },
    "knownFacts": {
        "title": "Bekannte Fakten",
        "description": "Einzelheiten zu den Informationen, die zwischen Ihnen und geteilt werden {{memoriName}}",
        "type": "Typ",
        "typeShortTerm": "Kurzfristig",
        "typeLongTerm": "Langfristig",
        "typeHelper": "Typen:\n",
        "text": "Text",
        "deleteSuccess": "Bekannte Tatsache gelöscht",
        "deleteConfirmTitle": "Bekannte Tatsache löschen",
        "deleteConfirmMessage": "Sind Sie sicher, dass Sie diese bekannte Tatsache löschen möchten?",
        "deleteSelectedConfirmTitle": "Ausgewählte bekannte Fakten löschen",
        "deleteSelectedConfirmMessage": "Sind Sie sicher, dass Sie die ausgewählten bekannten Fakten löschen möchten?"
    },
    "auth": {
        "title": "Authentifizierung",
        "useRecoveryTokens": "Verwenden Sie Wiederherstellungstoken",
        "tokens": "Token",
        "addToken": "Token hinzufügen",
        "usePassword": "Passwort verwenden",
        "passwordRequired": "Passwort erforderlich",
        "invalidCredentials": "Ungültige Zugangsdaten",
        "atLeast": "Mindestens"
    },
    "widget": {
        "instruct": "Anleiten",
        "test": "Testen",
        "sound": "Ton",
        "position": "Positionspräferenzen",
        "settings": "Einstellungen",
        "share": "Teilen",
        "shareChat": "Chat teilen",
        "sendOnKeypress": "Drücken Sie Enter zum Senden",
        "sendOnClick": "Klicken Sie auf Senden",
        "boardOfExperts": "Expertenrat",
        "showExpertsInTheBoard": "Experten in diesem Rat anzeigen",
        "expertsInTheBoard": "Experten in diesem Rat",
        "goToIntegrationsToCustomizeAvatar": "Um den Avatar anzupassen, gehen Sie zu \"Teilen\" und passen Sie die öffentliche Seite an"
    },
    "exportChatHistory": {
        "exportPDF": "Chat als PDF exportieren",
        "exporting": "Exportiere...",
        "empty": "Kein Chatverlauf zum Exportieren",
        "pdfNotSupported": "PDF-Export wird in diesem Browser nicht unterstützt",
        "success": "Chat erfolgreich als PDF exportiert",
        "error": "Fehler beim Exportieren des Chats als PDF. Bitte versuchen Sie es erneut."
    },
    "write_and_speak": {
        "micButtonPopover": "Klicken Sie auf die Schaltfläche, um zu sprechen",
        "micButtonPopoverListening": "Klicken Sie auf die Schaltfläche, um das Sprechen zu stoppen",
        "pageInstructExplanation": "Um mir neue Dinge beizubringen, klicken Sie auf die Schaltfläche \"ANLEITEN\", um zu beginnen",
        "pageTryMeExplanation": "Um mit mir zu sprechen, klicken Sie auf die Schaltfläche START, um zu beginnen",
        "pagePrivacyExplanation": "Die Konversationen sind sichtbar von dem Autor des Agenten",
        "downloadChat": "Chat herunterladen",
        "pagePrivacyExplanationList": {
            "allConversations": "Alle Konversationen mit diesem Agenten sind sichtbar von dem Autor des Agenten",
            "anonymousUser": "Für anonyme Benutzer: der Autor wird den Inhalt der Konversation und Ihre IP-Adresse sehen",
            "registeredUser": "Für registrierte Benutzer: der Autor wird den Inhalt der Konversation und Ihren Benutzernamen sehen",
            "contentAndUsername": "Der Autor kann den Inhalt, Ihren Benutzernamen und Ihre IP-Adresse sehen",
            "contentAndIpAddress": "Der Autor kann den Inhalt und Ihre IP-Adresse sehen",
            "authorUsesInfo": "Der Autor verwendet diese Informationen, um die Funktionen des Agenten zu verbessern und Ihnen einen besseren Service anzubieten. Wenn Sie die Konversation fortsetzen, stimmen Sie diesen Bedingungen zu."
        },
        "instructButton": "WEISE MICH AN",
        "tryMeButton": "START",
        "resumeButton": "FORTSETZEN",
        "chatHistory": "Chatverlauf",
        "chatHistoryDescription": "Chatverlauf mit diesem Agenten anzeigen",
        "loadingChatHistory": "Chatverlauf wird geladen...",
        "noChatHistoryAvailable": "Kein Chatverlauf verfügbar",
        "noResultsFound": "Keine Ergebnisse gefunden für \"{{searchText}}\"",
        "searchInChatHistory": "Im Chatverlauf suchen...",
        "latestFirst": "Neueste zuerst",
        "oldestFirst": "Älteste zuerst",
        "exportChat": "Chat exportieren",
        "conversationStartedLabel": "Unterhaltung gestartet",
        "settingsHeaderLabel": "Richten Sie hier ein, wenn Sie die Agent als Dauerrede einstellen möchten, und ändern Sie die Stillesekunden, wenn Sie sie anpassen möchten.",
        "continuousSpeechLabel": "Kontinuierliche Rede",
        "continuousSpeechDisabled": "Kontinuierliche Rede deaktiviert, da der Agent im Stummschaltmodus ist",
        "holdToSpeak": "Halten Sie gedrückt, um zu sprechen",
        "releaseToEndListening": "Lassen Sie los, um das Hören zu beenden",
        "pressAndHoldToSpeak": "Zum Sprechen gedrückt halten",
        "microphoneMode": "Mikrofonmodus",
        "hideEmissionsLabel": "Vom Zwilling ausgegebenen Text ausblenden",
        "secondsLabel": "Sekunden einstellen",
        "controlsPosition": "Steuert die Position",
        "tryMeHeaderLabel": "VERSUCHEN",
        "unknownPosition": "Unbekannte Position",
        "fieldPlace": "Geben Sie den Ort ein (z. B. \"Mailand\")",
        "showMapLinkFor": "Zeigen Sie die Position auf der Karte an",
        "useMyPosition": "Nutzen Sie meine Position",
        "myPosition": "Ihre Position",
        "updatingPosition": "Position wird aktualisiert...",
        "placeNotFound": "Ort nicht gefunden!",
        "requirePosition": "Geben Sie vor dem Start Ihre Position ein",
        "requirePositionHelp": "Zum Reden {{name}} Sie müssen entscheiden, ob Sie Ihre Position angeben oder nicht. ",
        "dontWantToProvidePosition": "Ich möchte meine Position nicht bekannt geben",
        "attachmentsLabel": "Bereichern Sie Ihre Botschaft",
        "iWantToTalkToIn": "Ich möchte mit reden {{name}} In",
        "message": "nachricht",
        "messages": "nachrichten",
        "page": "Seite {{current}} von {{total}}"
    },
    "artifact": {
        "close": "Schließen",
        "size": "Größe",
        "generated": "Generiert",
        "download": "Herunterladen",
        "print": "Drucken",
        "external": "In neuem Fenster öffnen",
        "type": "Typ",
        "fullscreen": "Vollbild",
        "exitFullscreen": "Vollbild beenden",
        "copy": "Kopieren",
        "generatedAt": "Generiert am",
        "open": "Öffnen",
        "code": "Code",
        "preview": "Vorschau",
        "copied": "Kopiert!",
        "error": "Fehler",
        "generatingPdf": "PDF wird generiert...",
        "copying": "Kopiere...",
        "moreCopyOptions": "Weitere Kopieroptionen",
        "copyAs": "Kopieren als",
        "downloadAsMarkdown": "Als Markdown herunterladen",
        "downloadRawMarkdownText": "Rohmarkdown-Text herunterladen",
        "downloadAsPdf": "Als PDF herunterladen",
        "exportAsPdfDocument": "Als PDF-Dokument exportieren",
        "downloadAsHtml": "Als HTML herunterladen",
        "downloadFormattedHtml": "Formatiertes HTML herunterladen",
        "viewMode": "Ansichtsmodus",
        "codeMode": "Code-Modus",
        "refresh": "Aktualisieren",
        "share": "Teilen",
        "downloadAsJson": "Als JSON herunterladen",
        "downloadJsonData": "JSON-Daten herunterladen",
        "downloadAsPng": "Als PNG herunterladen",
        "downloadPngImage": "PNG-Bild herunterladen",
        "downloadAsJpeg": "Als JPEG herunterladen",
        "downloadJpegImage": "JPEG-Bild herunterladen",
        "downloadAsGif": "Als GIF herunterladen",
        "downloadGifImage": "GIF-Bild herunterladen",
        "downloadAsWebp": "Als WebP herunterladen",
        "downloadWebpImage": "WebP-Bild herunterladen",
        "copyAsSvg": "Als SVG kopieren",
        "copySvgSourceCode": "SVG-Quellcode kopieren",
        "copyAsPlainText": "Als Klartext kopieren",
        "copyAsText": "Als Text kopieren",
        "copyAsLanguage": "Als {{language}} kopieren",
        "copyLanguageCode": "{{language}}-Code kopieren",
        "copyWithoutSyntaxHighlighting": "Ohne Syntaxhervorhebung kopieren",
        "copyTextContent": "Textinhalt kopieren",
        "pdfExportNotSupported": "PDF-Export wird in diesem Browser nicht unterstützt",
        "popupBlocked": "Popup blockiert! Bitte aktivieren Sie Popups zum Drucken.",
        "safariPdfInstructions": "PDF-Export in neuem Fenster geöffnet. Bitte verwenden Sie Cmd+P (Mac) oder Strg+P (Windows) zum Drucken und als PDF speichern."
    },
    "upload": {
        "loginRequired": "Login erforderlich",
        "pastedText": "text-eingefügt",
        "uploadNotification": "Hochladen fehlgeschlagen",
        "loginRequiredDescription": "Bitte melden Sie sich an, um Bilder hochzuladen",
        "uploadFiles": "Dateien hochladen ({{shortcut}}+O zum Öffnen des Datei-Selektors)",
        "uploadFilesWithShortcut": "{{shortcut}}+O zum Öffnen des Datei-Selektors",
        "uploadImages": "Bilder hochladen",
        "uploadDocuments": "Dokumente hochladen",
        "replace": "Ersetzen",
        "remaining": "verbleibend",
        "maxReached": "Maximal erreicht",
        "apiClientNotConfigured": "Client API nicht korrekt konfiguriert für das Hochladen von Medien",
        "fileReadingFailed": "Datei lesen fehlgeschlagen",
        "uploadFailed": "Hochladen fehlgeschlagen",
        "uploadSuccess": "Hochladen erfolgreich",
        "uploadSuccessDescription": "Die Datei wurde erfolgreich hochgeladen",
        "maxImagesReached": "Sie können bis zu {{max}} Bilder hochladen",
        "dragAndDropFiles": "Ziehen Sie Dateien hierher, um sie zur Chat hinzuzufügen",
        "contextSizeExceedsLimit": "Die Kontextgröße überschreitet das Limit. Reduzieren Sie die Anzahl der Dateien oder den Inhalt der Konversation.",
        "filesNotAddedMaxAllowed": "{{count}} Datei(en) nicht hinzugefügt (maximal {{max}} Dateien erlaubt).",
        "documentsNotAddedMaxAllowed": "{{count}} Dokument(e) nicht hinzugefügt (maximal {{max}} Dateien erlaubt).",
        "imagesNotAddedMaxAllowed": "{{count}} Bild(er) nicht hinzugefügt (maximal {{max}} Dateien erlaubt).",
        "documentsNotAddedContextSize": "{{count}} Dokument(e) nicht hinzugefügt (Kontextgrößen-Limit)."
    },
    "media": {
        "title": "Titel",
        "editAttributes": "Medienattribute bearbeiten",
        "uploadMimeTypeNotAllowed": "Der Dateityp ist nicht zulässig",
        "uploadSizeLimitMessage": "Die hochgeladene Größe ist zu groß (max {{size}}MB)",
        "uploadWrongResolutionMessage": "Die Auflösung muss sein {{width}}X{{height}} Pixel",
        "memoriNameAlreadyUsed": "Du hast bereits einen Zwilling mit diesem Namen",
        "uploadHelperImages": "Laden Sie eine Datei mit der Erweiterung PNG, JPG, JPEG oder GIF hoch und darf maximal eine Größe von haben {{size}}MB",
        "uploadHelper": "Laden Sie eine Datei mit einer maximalen Größe von hoch {{size}}MB",
        "uploadError": "Der Upload ist fehlgeschlagen",
        "square": "Quadrat",
        "scaleRatio": "Maßstabsverhältnis",
        "addMediaLabel": "Fügen Sie ein Medium hinzu",
        "insertThisMediaMsg": "Legen Sie diese Medien ein",
        "mediaUploadMessage": "Klicken Sie hier, um ein neues Medium zu laden",
        "addLinkLabel": "Fügen Sie einen Link hinzu",
        "linkKey": "URL",
        "linkValue": "Linktitel",
        "insertThisLink": "Fügen Sie einen Link ein {{url}} mit Titel {{title}}"
    },
    "gamification": {
        "level": "Ebene",
        "points": "Punkte",
        "memoriReachedLevel": "entwickelte sich weiter und erreichte ein höheres Niveau",
        "levelGoToStatistics": "{{memori}} ist auf gleicher Höhe {{level}} mit {{points}} Punkte. ",
        "congratulationsNewLevel": "Herzlichen Glückwunsch, Sie haben ein neues Level erreicht!",
        "congratulationsNewLevelDescription": "Ihre Agent wurden mit weiterentwickelt {{points}} Punkte, schauen Sie sich die an",
        "statistics": "Statistiken"
    },
    "login": {
        "login": "Login",
        "logout": "Abmelden",
        "user": "Benutzer",
        "loggedDrawerTitle": "Hallo, {{name}}!",
        "userNameRequired": "Benutzername erforderlich",
        "userName": "Benutzername",
        "userNamePlaceholder": "Geben Sie den Benutzernamen ein",
        "loginDrawerTitle": "Login",
        "signupDrawerTitle": "Melden Sie sich an",
        "newUserSignUp": "Neuer Benutzer?",
        "signUp": "Melden Sie sich an!",
        "alreadyHaveAnAccount": "Sie haben bereits ein Konto?",
        "backToLogin": "Zurück zum Login",
        "registrationDisabled": "Die Registrierung ist deaktiviert",
        "contactAdmin": "Wenden Sie sich an den Administrator, um Zugriff anzufordern",
        "userNameOrEmail": "Benutzername oder E-Mail",
        "email": "E-Mail",
        "emailFormatError": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
        "username": "Benutzername",
        "usernameContainsReservedWord": "Der Benutzername enthält ein reserviertes Wort. Bitte wählen Sie ein anderes",
        "usernameFormatError": "Der Benutzername muss mindestens 3 Zeichen lang sein und darf nur Buchstaben, Zahlen und _ enthalten.",
        "otpCode": "Bestätigungscode",
        "resendVerificationCode": "Code erneut senden",
        "resentVerificationCode": "Bestätigungscode gesendet! ",
        "welcomeTitle": "Willkommen zurück",
        "welcomeDescription": "Geben Sie Ihren 4-stelligen Bestätigungscode ein, um zu Ihrem Konto fortzufahren",
        "otpTitle": "Bestätigungscode eingeben",
        "otpDescription": "Geben Sie den 4-stelligen Code ein, den Sie in Ihrem Konto generiert haben",
        "otpStep1": "Klicken Sie auf die Schaltfläche unten, um Ihr Konto zu öffnen",
        "otpStep2": "Generieren Sie einen 4-stelligen Bestätigungscode (60 Sekunden gültig)",
        "otpStep3": "Kehren Sie hierher zurück und geben Sie den Code ein",
        "startOtpLogin": "Verifizierung starten",
        "generateOtp": "Code generieren",
        "otpTimer": "Code läuft in {{seconds}} Sekunden ab",
        "otpInvalidFormat": "Bitte geben Sie einen gültigen 4-stelligen Code ein",
        "otpInvalid": "Ungültiger Bestätigungscode",
        "otpError": "Fehler bei der Code-Validierung. Bitte versuchen Sie es erneut.",
        "otpSuccess": "Anmeldung erfolgreich!",
        "password": "Passwort",
        "newPassword": "Neues Passwort",
        "confirmPassword": "Passwort bestätigen",
        "currentPassword": "Aktuelles Passwort",
        "passwordMatchingError": "Passwörter stimmen nicht überein.",
        "passwordFormatError": "Das Passwort muss mindestens 8 Zeichen lang sein und mindestens eine Zahl, einen Großbuchstaben, einen Kleinbuchstaben und ein Symbol enthalten",
        "pwdWeak": "Schwach",
        "pwdAcceptable": "Akzeptabel",
        "pwdStrong": "Stark",
        "mustChangePassword": "Sie müssen Ihr Passwort ändern",
        "passwordChange": "Kennwort ändern",
        "emailChange": "E-Mail ändern",
        "avatarChange": "Avatar ändern",
        "underage": "Das müssen Sie mindestens sein {{age}} Jahre alt, um sich anzumelden.",
        "optional": "Optional",
        "birthDate": "Geburtsdatum",
        "birthDateHelper": "Wir fragen nur nach Ihrem Geburtsdatum, um Funktionen zu aktivieren oder zu deaktivieren, für die Altersbeschränkungen gelten",
        "missingData": "Fehlende Informationen",
        "missingDataHelper": "Wir wissen, dass dies etwas nervig ist, benötigen jedoch noch einige weitere Informationen, um Ihre Registrierung abzuschließen.",
        "goToAccountToChangeYourPreferences": "Sie können Ihre Auswahl jederzeit auf Ihrer Kontoseite ändern.",
        "deepThoughtExplaination": "Deep Thought ist eine erweiterte Funktion der KI, die es Ihnen ermöglicht, Ihre Gespräche voll auszuschöpfen, indem Sie sie verfolgen. ",
        "tnCAndPPAcceptedHelper": "Seit Ihrer letzten Anmeldung haben sich die AGB und Datenschutzbestimmungen geändert. ",
        "privacyLabel": "Ich habe die gelesen und akzeptiert",
        "privacyAndCookiePolicy": "Datenschutz und Cookie-Richtlinie",
        "and": "Und",
        "termsOfService": "Nutzungsbedingungen",
        "pAndCUAccepted": "Ich akzeptiere die Nutzungsbedingungen von Deep Thought",
        "editAccount": "Konto bearbeiten",
        "save": "Speichern",
        "successfullyLoggedIn": "{{username}} hat sich erfolgreich angemeldet"
    },
    "chatLogs": {
        "anyMessage": "Jede Nachricht",
        "atLeast": "Mindestens {{count}} Nachrichten",
        "atLeast2": "Mindestens 2 Nachrichten",
        "atLeast3": "Mindestens 3 Nachrichten",
        "atLeast5": "Mindestens 5 Nachrichten",
        "atLeast10": "Mindestens 10 Nachrichten",
        "atLeast15": "Mindestens 15 Nachrichten",
        "atLeast20": "Mindestens 20 Nachrichten",
        "customMinimumMessages": "Anpassen Sie die Anzahl der Nachrichten"
    },
    "success": "Erfolg",
    "Error": "Fehler",
    "internal server error": "Oupsie, tut mir leid... Auf dem Server ist ein Fehler aufgetreten",
    "error": "Fehler",
    "error.loading": "Fehler beim Laden des Inhalts.",
    "error.generic": "Oupsie, tut mir leid ... etwas ist schief gelaufen.",
    "error.serverNotResponding": "Wir führen Wartungsarbeiten durch oder veröffentlichen Updates. ",
    "error.notFound": "Oupsie, wir haben die von Ihnen gesuchte Seite nicht gefunden.",
    "error.goBackTo": "Sie können versuchen, dorthin zurückzukehren",
    "error.reloadPage": "Laden Sie die Seite neu",
    "error.tryAgain": "Versuchen Sie es erneut",
    "error.unauthorized": "Es ist Ihnen nicht gestattet, diesen Inhalt anzuzeigen.",
    "error.unprocessableEntity": "Fehler beim Verarbeiten der Anfrage. ",
    "errors": {
        "TENANT_NOT_FOUND": "Mieter nicht gefunden",
        "TENANT_REGISTRATION_DISABLED": "Die Registrierung auf dieser Plattform ist deaktiviert",
        "TENANT_MISSING_NAME": "Mieter: Name fehlt",
        "TENANT_MAX_USERS_REACHED": "Maximale Anzahl Benutzer erreicht",
        "TENANT_MAX_ADMINS_REACHED": "Maximale Anzahl an Admin-Benutzern erreicht",
        "TENANT_ALREADY_EXISTS": "Mieter existiert bereits",
        "TENANT_MISSING_DESCRIPTION": "Mieter: Beschreibung fehlt",
        "TENANT_CANT_SET_COMPLETION_PROVIDER": "Mandant: Abschlussanbieter kann nicht festgelegt werden",
        "TENANT_INVALID_TYPE": "Mandant: ungültiger Typ",
        "USER_NOT_CONFIRMED": "Benutzer noch nicht bestätigt",
        "USER_NOT_FOUND": "Benutzer nicht gefunden",
        "USER_OR_PASSWORD_INVALID": "Ungültiger Benutzer oder Passwort",
        "USER_MUST_CHANGE_PASSWORD": "Sie müssen Ihr Passwort ändern",
        "USER_MUST_ENTER_VERIFICATION_CODE": "Sie müssen den Bestätigungscode eingeben",
        "USER_MISSING_TENANT": "Benutzer: Mieter fehlt",
        "USER_MISSING_NAME": "Benutzer: Name fehlt",
        "USER_MISSING_PASSWORD": "Benutzer: Passwort fehlt",
        "USER_MISSING_EMAIL": "Benutzer: Fehlende E-Mail",
        "USER_MISSING_VERIFICATION_CODE": "Benutzer: Fehlender Bestätigungscode",
        "USER_NAME_ALREADY_USED": "Benutzername wird bereits verwendet",
        "USER_PASSWORD_NOT_CONFORMING_TO_POLICY": "Das Passwort entspricht nicht den Sicherheitsregeln",
        "USER_EMAIL_ALREADY_USED": "E-Mail wird bereits verwendet",
        "USER_EMAIL_INVALID": "Ungültige E-Mail",
        "USER_VERIFICATION_CODE_INVALID": "Ungültiger Bestätigungscode",
        "USER_MISSING_NAME_OR_EMAIL": "Benutzername oder E-Mail fehlen",
        "USER_NAME_INVALID": "Ungültiger Benutzername",
        "USER_HAS_ONE_OR_MORE_MEMORI": "Der Benutzer verfügt über eine oder mehrere Erinnerungen",
        "USER_MISSING_NEW_PASSWORD": "Benutzer: Neues Passwort fehlt",
        "USER_NOTHING_TO_DO": "Nichts zu tun",
        "USER_CANT_CREATE_MEMORI": "Benutzer darf Agent nicht erstellen",
        "USER_MAX_MEMORI_REACHED": "Maximale Anzahl an Agent erreicht",
        "USER_TOO_MANY_ATTEMPTS": "Zu viele Versuche",
        "USER_MUST_ACCEPT_TNC_AND_PP": "Sie müssen die Allgemeinen Geschäftsbedingungen akzeptieren",
        "USER_BIRTH_DATE_CANT_BE_CHANGED": "Das Geburtsdatum kann nicht geändert werden",
        "USER_CANT_SET_COMPLETION_PROVIDER": "Benutzer: darf den Vervollständigungsanbieter nicht verwalten",
        "USER_CANT_ENABLE_DEEP_THOUGHT": "Benutzer: nicht für die Verwaltung von Deep Thought aktiviert",
        "USER_CANT_ENABLE_DCM_INTEGRATION": "Benutzer: nicht für die Verwaltung der DCM-Integration aktiviert",
        "USER_CANT_ENABLE_CHAINING_OR_BOARD_OF_EXPERTS": "Benutzer: darf die Verkettung oder Expertengruppe nicht verwalten",
        "USER_CREATION_BILLING_DENIED_PERMISSION": "Sie haben nicht genügend Credits, um einen Zwilling zu erstellen",
        "USER_HAS_ONE_OR_MORE_COMPLETION_CONFIGS": "Der Benutzer verfügt über eine oder mehrere Abschlusskonfigurationen",
        "USER_CANT_BE_DELETED": "Benutzer kann nicht gelöscht werden",
        "USER_ORDER_BY_INVALID": "Ungültige Sortierreihenfolge",
        "MEMORI_NOT_FOUND": "Erinnerungen nicht gefunden",
        "MEMORI_NOT_ACCESSIBLE": "Agent nicht zugänglich",
        "MEMORI_ONLY_OWNER_CAN_CHANGE_GIVER_TAG_AND_PIN": "Nur der Eigentümer kann das Tag oder die PIN ändern",
        "SESSION_NOT_FOUND": "Sitzung nicht gefunden",
        "SESSION_IS_NOT_ADMINISTRATIVE": "Nicht-administrative Sitzung",
        "SESSION_EXPIRED": "Sitzung abgelaufen",
        "MEMORI_MISSING_CONFIGURATION": "Zwilling: fehlende Konfiguration",
        "MEMORI_CONFIGURATION_NOT_FOUND": "Zwilling: Konfiguration nicht gefunden",
        "MEMORI_INVALID_PRIVACY_TYPE": "Agent: ungültiger Datenschutztyp",
        "MEMORI_MISSING_PASSWORD": "Zwilling: Passwort fehlt",
        "MEMORI_INVALID_TOTAL_NUMBER_OF_RECOVERY_TOKENS": "Agent: Gesamtzahl ungültiger Wiederherstellungstokens",
        "MEMORI_INVALID_MINIMUM_NUMBER_OF_RECOVERY_TOKENS": "Agent: Mindestanzahl ungültiger Wiederherstellungstokens",
        "MEMORI_INVALID_VOICE_TYPE": "Zwilling: ungültiger Stimmtyp",
        "MEMORI_MISSING_NAME": "Zwilling: fehlender Name",
        "MEMORI_MISSING_PASSWORD_OR_RECOVERY_TOKENS": "Zwilling: Fehlendes Passwort oder Wiederherstellungstoken",
        "MEMORI_INVALID_ID": "Zwilling: ungültige ID",
        "MEMORI_NAME_ALREADY_USED": "Zwillingsname wird bereits verwendet",
        "MEMORI_INVALID_PIN": "Zwilling: Ungültige PIN",
        "MEMORI_GIVER_TAG_PIN_CHANGE_REQUIRES_SEPARATE_OPERATION": "Zwilling: TAG- und PIN-Änderung erfordern separate Vorgänge",
        "MEMORI_NO_PASSWORD_WHEN_PUBLIC": "Zwilling: Im öffentlichen Zustand ist kein Passwort erforderlich",
        "MEMORI_DEEP_THOUGHT_REQUIRES_COMPLETIONS": "Für \"Deep Thought\" müssen Vervollständigungen aktiviert sein",
        "MEMORI_BOARD_OF_EXPERTS_REQUIRES_COMPLETIONS": "Für die Expertengruppe müssen Vervollständigungen aktiviert sein",
        "MEMORI_INVALID_COMPLETION_CONFIG": "Zwilling: Ungültige Abschlusskonfiguration",
        "MEMORI_MACRO_FUNCTIONS_REQUIRES_COMPLETIONS": "Für die Makrofunktionen müssen Vervollständigungen aktiviert sein",
        "MEMORI_BLOCKING_DATE_MISSING_OR_WRONG": "Zwilling: fehlende oder falsche Blockierungsdatum",
        "MEMORI_LIST_FILTER_NOT_SPECIFIED": "Zwilling: fehlender Filter",
        "MEMORI_TRANSFER_MISSING_DESTINATION_USER": "Übertragung: Zielbenutzer fehlt",
        "MEMORI_TRANSFER_INVALID_DESTINATION_USER_ID": "Übertragung: Ungültige Zielbenutzer-ID",
        "MEMORI_TRANSFER_DESTINATION_USER_DATA_INCONSISTENT": "Übertragung: Ungültige Zielbenutzerdaten",
        "MEMORI_TRANSFER_NOTHING_TO_DO": "Transfer: nichts zu tun",
        "MEMORI_CONFIGURATION_CANT_BE_CHANGED": "Speicher: Konfiguration kann nicht geändert werden",
        "MEMORI_MISSING_NEW_PASSWORD": "Erinnerungen: Neues Passwort fehlt",
        "MEMORI_FEATURE_REQUIRES_SUBSCRIPTION": "Für die Funktion ist ein Abonnement erforderlich",
        "INTEGRATION_NOT_FOUND": "Integration nicht gefunden",
        "MEMORI_SESSIONS_INVALID_DATE_FROM_FORMAT": "Ungültiges Datum aus Format",
        "MEMORI_SESSIONS_INVALID_DATE_TO_FORMAT": "Ungültiges Datum zum Formatieren",
        "MEMORI_SESSION_NOT_FOUND": "Sitzung nicht gefunden",
        "MEMORI_SESSION_DOESNT_ACCEPT_MEDIA": "Sitzung akzeptiert keine Medien",
        "INTEGRATION_INVALID_TYPE": "Ungültiger Integrationstyp",
        "INTEGRATION_ALREADY_EXISTS": "Die Integration ist bereits vorhanden",
        "INTEGRATION_MEMORI_IS_NOT_PUBLIC": "Nicht-öffentliche Erinnerungen können nicht integriert werden",
        "INTEGRATION_MISSING_INVOCATION_TEXT": "Integration: fehlender Aufruftext",
        "INTEGRATION_MISSING_DEVICE_EMAILS": "Integration: Fehlende Geräte-E-Mail",
        "INTEGRATION_MEMORI_IS_EMPTY": "Leere Erinnerungen können nicht integriert werden",
        "INTEGRATION_MISSING_PRIVACY_POLICY": "Integration: Datenschutzrichtlinie fehlt",
        "INTEGRATION_MISSING_CATEGORY": "Integrationskategorie fehlt",
        "INTEGRATION_MISSING_DESCRIPTION": "Fehlende Integrationsbeschreibung",
        "INTEGRATION_INVALID_INVOCATION_TEXT": "Ungültiger Aufruftext",
        "INTEGRATION_GOOGLE_NO_MORE_AVAILABLE": "Google Home nicht mehr verfügbar",
        "UPLOAD_REQUIRES_MULTIPART_ENCODING": "Für den Upload ist eine mehrteilige Kodierung erforderlich",
        "UPLOAD_MISSING_CONTENT_TYPE_BOUNDARY": "Hochladen: Inhaltstypgrenze fehlt",
        "UPLOAD_MAX_LENGTH_EXCEEDED": "Upload: Maximale Größe überschritten",
        "UPLOAD_FILE_IS_EMPTY": "Hochladen: leere Datei",
        "UPLOAD_INVALID_FILE_TYPE_OR_SIGNATURE": "Hochladen: Ungültiger Dateityp oder ungültige Signatur",
        "UPLOAD_MISSING_FILE_NAME": "Hochladen: Dateiname fehlt",
        "UPLOAD_INVALID_MEMORY_ID": "Hochladen: Ungültige Inhalts-ID",
        "UPLOAD_MISSING_FILE_CONTENT": "Hochladen: Dateiinhalt fehlt",
        "ASSET_NOT_FOUND": "Asset nicht gefunden",
        "ASSET_NOT_ACCESSIBLE": "Asset nicht zugänglich",
        "ASSET_MISSING_SESSION_ID": "Asset: Sitzungs-ID fehlt",
        "ASSET_INVALID_FILE_NAME": "Asset: ungültiger Dateiname",
        "ASSET_MALWARE_SCAN_THREATS_FOUND": "Asset: malware scan threats found",
        "INVITATION_NOT_FOUND": "Einladung nicht gefunden",
        "INVITATION_NOT_ACCESSIBLE": "Einladung nicht zugänglich",
        "INVITATION_ALREADY_ACCEPTED": "Einladung bereits angenommen",
        "INVITATION_ALREADY_REJECTED": "Einladung bereits abgelehnt",
        "INVITATION_MISSING_DESTINATION_EMAIL": "Einladung: Ziel-E-Mail fehlt",
        "INVITATION_DESTINATION_EMAIL_INVALID": "Einladung: Ziel-E-Mail-Adresse ungültig",
        "INVITATION_MISSING_TAG": "Einladung: Tag fehlt",
        "INVITATION_MISSING_PIN": "Einladung: PIN fehlt",
        "INVITATION_INVALID_PIN": "Einladung: ungültige PIN",
        "INVITATION_INVALID_TYPE": "Einladung: ungültiger Typ",
        "INVITATION_MISSING_DESTINATION_NAME": "Einladung: Zielname fehlt",
        "INVITATION_TAG_PIN_CANT_BE_CHANGED": "Einladung: Tag und Pin können nicht geändert werden",
        "INVITATION_CANT_BE_CHANGED": "Absicht: kann nicht geändert werden",
        "ACTIONLOG_INVALID_USER_ID": "Ungültige Benutzer-ID",
        "ACTIONLOG_INVALID_DATE_FROM_FORMAT": "Datum von: ungültiges Format",
        "ACTIONLOG_INVALID_DATE_TO_FORMAT": "Datum bis: ungültiges Format",
        "ACTIONLOG_INVALID_MEMORI_ID": "Ungültige Memori-ID",
        "CONSUMPTIONLOG_INVALID_TYPE": "Ungültiger Protokolltyp",
        "CONSUMPTIONLOG_INVALID_DATE_FROM_FORMAT": "Datum von: ungültiges Format",
        "CONSUMPTIONLOG_INVALID_DATE_TO_FORMAT": "Datum bis: ungültiges Format",
        "CONSUMPTIONLOG_INVALID_USER_ID": "Ungültige Benutzer-ID",
        "CONSUMPTIONLOG_INVALID_MEMORI_ID": "Ungültige Memori-ID",
        "NOTIFICATIONPREFS_INVALID_CHATLOG_EXTRACTION_PERIOD": "Benachrichtigungen: Ungültiger Chat-Protokoll-Extraktionszeitraum",
        "BROADCAST_NOT_ALLOWED": "Broadcast nicht erlaubt",
        "INVALID_NOTIFICATION_TYPE": "Ungültiger Benachrichtigungstyp",
        "NOTIFICATION_NOT_FOUND": "Benachrichtigung nicht gefunden",
        "INVALID_NOTIFICATION_FILTER": "Ungültiger Benachrichtigungsfilter",
        "INVALID_NOTIFICATION_PERIOD": "Ungültiger Benachrichtigungszeitraum",
        "PROCESS_INVALID_TYPE": "Ungültiger Prozesstyp",
        "PROCESS_ALREADY_RUNNING": "Prozess läuft bereits",
        "PROCESS_NOT_FOUND": "Prozess nicht gefunden",
        "IMPORTCSV_MISSING_ROWS": "CSV-Import: fehlende Zeilen",
        "IMPORTCSV_MISSING_CSV": "CSV-Import: CSV fehlt",
        "IMPORTCSV_MISSING_SEPARATOR": "CSV-Import: fehlendes Trennzeichen",
        "IMPORTCSV_INVALID_SEPARATOR": "CSV-Import: Ungültiges Trennzeichen",
        "IMPORTCSV_MISSING_HEADERS": "CSV-Import: fehlende Header",
        "IMPORTCSV_MISSING_TITLE_VARIANT_SEPARATOR": "CSV-Import: Titelvariantentrennzeichen fehlt",
        "IMPORTCSV_INVALID_RECEIVER_ID": "CSV-Import: ungültige Empfänger-ID",
        "IMPORTCSV_INVALID_MEDIA_LINK": "CSV-Import: Ungültiger Medienlink",
        "IMPORTCSV_INVALID_LINK_TITLE_HANDLING": "CSV-Import: Ungültiger Linktitel",
        "IMPORTCSV_UNDETECTABLE_CHAR_ENCODING": "CSV-Import: Nicht erkennbare Zeichenkodierung",
        "IMPORTCSV_CANT_IMPORT_TO_SECRET_MEMORI": "CSV-Import: Der Import in Secret Memories ist nicht möglich",
        "IMPORTTXT_MISSING_ROWS": "TXT wird importiert: Zeilen fehlen",
        "IMPORTTXT_INVALID_GRANULARITY": "TXT importieren: ungültige Granularität",
        "IMPORTTXT_INVALID_RECEIVER_ID": "TXT importieren: ungültige Empfänger-ID",
        "IMPORTTXT_INVALID_MEDIA_LINK": "TXT importieren: Ungültiger Medienlink",
        "IMPORTTXT_INVALID_LINK_TITLE_HANDLING": "TXT importieren: ungültiger Linktitel",
        "IMPORTTXT_UNDETECTABLE_CHAR_ENCODING": "TXT-Import: Nicht erkennbare Zeichenkodierung",
        "IMPORTTXT_CANT_IMPORT_TO_SECRET_MEMORI": "TXT-Import: Der Import in Secret Memories ist nicht möglich",
        "IMPORTTXT_IMPORT_LIMIT_EXCEEDED": "TXT importieren: Importlimit überschritten",
        "IMPORTTXT_IMPORT_ON_GPT4_REQUIRES_API_KEY": "TXT importieren: Für den Import auf GPT-4 ist ein API-Schlüssel erforderlich",
        "IMPORTTXT_IMPORT_REQUIRES_PAYING": "TXT importieren: Für den Import ist ein kostenpflichtiger Plan erforderlich",
        "IMPORTTXT_BILLING_DENIED_PERMISSION": "TXT importieren: Sie haben nicht genügend Credits für den Vorgang",
        "IMPORT_MISSING_ROWS": "Import: fehlende Zeilen",
        "IMPORT_CANT_IMPORT_TO_SECRET_MEMORI": "Import: Der Import in Secret Memories ist nicht möglich",
        "IMPORTMEMORI_INVALID_MEMORI_SPECS": "Import MEMORI: ungültige Agentenspezifikationen",
        "IMPORT_MISSING_JSONL": "Import: JSONL fehlt",
        "IMPORTMEMORI_INVALID_SPECS": "Import MEMORI: ungültige Spezifikationen",
        "EXPORT_MISSING_PASSWORD": "Export: Passwort fehlt",
        "EXPORTCSV_MISSING_CSV_SPECS": "CSV-Export: CSV-Spezifikationen fehlen",
        "EXPORTCSV_MISSING_SEPARATOR": "CSV-Export: fehlendes Trennzeichen",
        "EXPORTCSV_INVALID_SEPARATOR": "CSV-Export: Ungültiges Trennzeichen",
        "EXPORTCSV_MISSING_TITLE_VARIANT_SEPARATOR": "CSV-Export: fehlendes Titelvarianten-Trennzeichen",
        "EXPORTCSV_MISSING_NEW_LINE_CHAR": "CSV-Export: Fehlendes Zeilenumbruchzeichen",
        "EXPORTCSV_INVALID_NEW_LINE_CHAR": "CSV-Export: Ungültiges Zeilenumbruchzeichen",
        "EXPORTCSV_MISSING_PASSWORD": "CSV-Export: Passwort fehlt",
        "EXPORTJSONL_MISSING_JSONL_SPECS": "JSONL-Export: JSONL-Spezifikationen fehlen",
        "EXPORTJSONL_MISSING_PLATFORM": "JSONL-Export: fehlende Plattform",
        "EXPORTJSONL_INVALID_PLATFORM": "JSONL-Export: ungültige Plattform",
        "EXPORTJSONL_MISSING_PASSWORD": "JSONL-Export: Passwort fehlt",
        "EXPORTJSONL_EXPORT_REQUIRES_PAYING": "JSONL-Export: Für den Export ist ein kostenpflichtiger Plan erforderlich",
        "ANALYSIS_MISSING_QUERY": "Analyse: fehlende Abfrage",
        "ANALYSIS_CANT_ANALYZE_SECRET_MEMORI": "Analyse: Geheime Erinnerungen können nicht analysiert werden",
        "ANALYSIS_USER_QUERY_MATCH_REQUIRES_DEEP_THOUGHT": "Analyse: Passende Benutzeranfragen erfordern tiefes Denken",
        "BADGE_ASSIGNMENT_WRONG_OR_MISSING_CREDENTIALS": "Ausweiszuweisung: falsche oder fehlende Zugangsdaten",
        "BADGE_ASSIGNMENT_MISSING_REF_ID": "Badge-Zuordnung: Referenz-ID fehlt",
        "BADGE_ASSIGNMENT_OUTCOME_NOT_FOUND": "Badge-Zuweisung: Ergebnis nicht gefunden",
        "BADGE_ASSIGNMENT_MISSING_ASSERTION_URL": "Badge-Zuweisung: Fehlende Behauptungs-URL",
        "BADGE_ASSIGNMENT_MISSING_BADGE_URL": "Badge-Zuweisung: Badge-URL fehlt",
        "BADGE_ASSIGNMENT_MISSING_ISSUER_URL": "Badge-Zuweisung: Aussteller-URL fehlt",
        "BADGE_ASSIGNMENT_INVALID_URL": "Badge-Zuweisung: Ungültige URL",
        "BADGE_ASSIGNMENT_MISSING_RECIPIENT": "Ausweiszuordnung: fehlender Empfänger",
        "BADGE_ASSIGNMENT_UNKNOWN_RECIPIENT_TYPE": "Badge-Zuordnung: unbekannter Empfängertyp",
        "BADGE_ASSIGNMENT_MISSING_RECIPIENT_IDENTITY": "Ausweiszuordnung: Empfängeridentität fehlt",
        "BADGE_ASSIGNMENT_MISSING_RECIPIENT_HASH_TYPE": "Badge-Zuweisung: Empfänger-Hash-Typ fehlt",
        "BADGE_ASSIGNMENT_UNKNOWN_RECIPIENT_HASH_TYPE": "Badge-Zuweisung: Empfänger-Hash-Typ unbekannt",
        "BADGE_ASSIGNMENT_WRONG_RECIPIENT_IDENTITY": "Badge-Zuordnung: Falsche Empfängeridentität",
        "BADGE_NOT_FOUND": "Abzeichen nicht gefunden",
        "OUTCOME_NO_DCM_CONFIGURED": "Ergebnis: kein DCM konfiguriert",
        "OUTCOME_USER_BADGES_DISABLED": "Ergebnis: Benutzerausweise deaktiviert",
        "COMPLETION_CONFIG_MISSING_NAME": "Vervollständigungskonfiguration: Name fehlt",
        "COMPLETION_CONFIG_MISSING_PROVIDER": "Vervollständigungskonfiguration: fehlender Anbieter",
        "COMPLETION_CONFIG_MISSING_ENDPOINT": "Abschlusskonfiguration: fehlender Endpunkt",
        "COMPLETION_CONFIG_MISSING_API_KEY": "Vervollständigungskonfiguration: fehlender API-Schlüssel",
        "COMPLETION_CONFIG_MISSING_MODEL": "Vervollständigungskonfiguration: fehlendes Modell",
        "COMPLETION_CONFIG_NO_PURPOSE_SPECIFIED": "Vervollständigungskonfiguration: Es muss mindestens ein Vervollständigungstyp angegeben werden",
        "COMPLETION_CONFIG_INVALID_NAME": "Vervollständigungskonfiguration: ungültiger Name",
        "COMPLETION_CONFIG_INVALID_PURPOSE": "Vervollständigungskonfiguration: Ungültiger Vervollständigungstyp",
        "COMPLETION_CONFIG_INVALID_ENDPOINT": "Abschlusskonfiguration: Ungültiger Endpunkt",
        "COMPLETION_CONFIG_INCONSISTENT_ENDPOINT": "Abschlusskonfiguration: inkonsistenter Endpunkt",
        "COMPLETION_CONFIG_INVALID_PROVIDER": "Vervollständigungskonfiguration: ungültiger Anbieter",
        "COMPLETION_CONFIG_NOT_FOUND": "Vervollständigungskonfiguration: nicht gefunden",
        "COMPLETION_CONFIG_NOT_ACCESSIBLE": "Vervollständigungskonfiguration: nicht zugänglich",
        "COMPLETION_CONFIG_NAME_RESERVED": "Vervollständigungskonfiguration: Name reserviert",
        "COMPLETION_CONFIG_NAME_ALREADY_EXISTS": "Vervollständigungskonfiguration: Name existiert bereits",
        "COMPLETION_CONFIG_VISIBILITY_CHANGE_NOT_ALLOWED": "Vervollständigungskonfiguration: Änderung der Sichtbarkeit nicht zulässig",
        "COMPLETION_CONFIG_MISSING_MANDATORY_PREFIX": "Vervollständigungskonfiguration: Pflichtpräfix fehlt",
        "COMPLETION_CONFIG_VISIBILITY_NOT_PERMITTED": "Vervollständigungskonfiguration: Sichtbarkeit nicht erlaubt",
        "COMPLETION_CONFIG_USE_AS_DEFAULT_NOT_PERMITTED": "Vervollständigungskonfiguration: Verwendung als Standard nicht erlaubt",
        "COMPLETION_CONFIG_USE_AS_DEFAULT_REQUIRES_TENANT_VISIBILITY": "Vervollständigungskonfiguration: Verwendung als Standard erfordert Mandantensichtbarkeit",
        "COMPLETION_CONFIG_CHARGEABLE_NOT_PERMITTED": "Vervollständigungskonfiguration: Chargeable nicht erlaubt",
        "COMPLETION_CONFIG_INVALID_APPLY_TO": "Vervollständigungskonfiguration: Ungültige Anwendung",
        "COMPLETION_CONFIG_APPLY_TO_TENANT_NOT_ALLOWED": "Vervollständigungskonfiguration: Anwendung auf Mandant nicht erlaubt",
        "TRUSTED_APPLICATION_NOT_FOUND": "Vertrauenswürdige Anwendung nicht gefunden",
        "TRUSTED_APPLICATION_NOT_ACCESSIBLE": "Vertrauenswürdige Anwendung nicht zugänglich",
        "TRUSTED_APPLICATION_NAME_REQUIRED": "Vertrauenswürdige Anwendung: Name erforderlich",
        "TRUSTED_APPLICATION_TOKEN_REQUIRED": "Vertrauenswürdige Anwendung: Token erforderlich",
        "TRUSTED_APPLICATION_NAME_ALREADY_EXISTS": "Vertrauenswürdige Anwendung: Name existiert bereits",
        "TRUSTED_APPLICATION_INVALID_TOKEN": "Vertrauenswürdige Anwendung: Ungültiger Token"
    }
}
